import { API, Auth } from 'aws-amplify';

 const query = /* GraphQL */ `
  query GetServicesHealthHistory($services: [String], $from: AWSDateTime, $to: AWSDateTime) {
    getServicesHealthHistory(services: $services, from: $from, to: $to) {
      ... on GetServicesHealthHistorySuccess {
        __typename
        result {
          ServiceHealthHistory {
            Service
            History {
              date
              health
              healthPercentage
              failureRatio
              e2eTestsUpdatedAt
              healthUpdatedAt
            }
          }
        }
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
    }
  }
`;

export interface GetServicesHealthHistoryVariables {
  brands?: number[];
  services?: string[];
  from?: string;
  to?: string;
}

interface PlatformHealthHistory {
  date: string;
  health: string;
  healthPercentage: number;
  failureRatio: number;
  e2eTestsUpdatedAt: string;
  healthUpdatedAt: string;
}

export interface ServiceHealthHistory {
  Service: string;
  History: PlatformHealthHistory[];
}

export interface GetServicesHealthHistoryResult {
  ServiceHealthHistory: ServiceHealthHistory[];
}

interface GraphQLResponse {
  __typename: string;
  result?: GetServicesHealthHistoryResult;
  message?: string;
  statusCode?: number;
}

async function getServicesHealthHistoryService({
  services,
  from,
  to,
}: GetServicesHealthHistoryVariables): Promise<GetServicesHealthHistoryResult> {
  try {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query,
      variables: {
        services,
        from,
        to,
      },
      authToken: user.signInUserSession.accessToken.jwtToken,
    }) as { data: { getServicesHealthHistory: GraphQLResponse } };

    if (!postData.data) {
      throw new Error('Internal Server Error');
    }

    const response = postData.data.getServicesHealthHistory;

    if (response.__typename === 'GetServicesHealthHistorySuccess' && response.result) {
      return response.result;
    }

    throw new Error(response.message || 'Unknown error occurred');
  } catch (error: any) {
    console.error('Error in getServicesHealthHistory:', error);
    throw new Error(`Internal Server Error: ${error.errors ? error.errors[0].message : error.message}`);
  }
}

export default getServicesHealthHistoryService;